/**
 * CompareSnapshotLabel.js
 */

import React from 'react';
import styled from 'styled-components';
import {lightColor} from '@ey/styled-theme';
import Utility from '../../../util/utilityfunctions';
import EllipsesControl from '../../Common/EllipsesControl/EllipsesControl';

export default function CompareSnapshotLabel(props) {
	const {snapshotObject, isTrackChanges = false} = props;

	return (
		<Wrapper className="BadgeTextWrapper">
			{Utility.getSnapshotCompareLabel(snapshotObject, isTrackChanges) !== undefined && (
				<section
					className={`badge-text ${snapshotObject.isAdded ? 'New' : ''} ${snapshotObject.isDeleted ? 'Removed' : ''}`}
				>
					<EllipsesControl
						content={Utility.getSnapshotCompareLabel(snapshotObject, isTrackChanges)}
						tooltip={Utility.getSnapshotCompareLabel(snapshotObject, isTrackChanges)}
						noOfLines={1}
					/>
				</section>
			)}
		</Wrapper>
	);
}

const Wrapper = styled.section`
	min-width: var(--px-100);
	margin-left: auto;
	padding-left: var(--px-10);
	.badge-text {
		font-size: var(--px-12);
		padding: var(--px-7) var(--px-12);
		line-height: var(--px-16);
		width: 100%;
		background-color: var(--orange-50);
		color: var(--neutrals-900);
		border-radius: var(--px-22);
		border: var(--px-1) solid var(--orange-200);
		.ellipses {
			justify-content: center;
			div {
				font-size: var(--px-12) !important;
				line-height: var(--px-16) !important;
				font-weight: 400 !important;
				color: var(--neutrals-900) !important;
			}
		}
		&.New {
			background-color: var(--green-25);
			color: var(--neutrals-900);
			border-color: var(--green-400);
		}
		&.Removed {
			background-color: var(--red-600);
			color: var(--neutrals-00white);
			border-color: var(--red-600);
			.ellipses {
				div {
					color: var(--neutrals-00white) !important;
				}
			}
		}
	}
`;
